import axios from 'axios';

export const AUTH_URL = process.env.REACT_APP_AUTH_URL ?? 'http://localhost:5028';

const TOKEN_KEY = 'kmg_admin_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
export const isAuthenticated = () => !!getToken();
export const logout = () => clearToken();

// Flow "password" OpenIddict : identifiant/mot de passe -> access token JWT.
export const login = async (username, password) => {
  const body = new URLSearchParams();
  body.append('grant_type', 'password');
  body.append('username', username);
  body.append('password', password);
  body.append('client_id', 'admin-spa');
  body.append('scope', 'api');

  const { data } = await axios.post(`${AUTH_URL}/connect/token`, body, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });

  setToken(data.access_token);
  return data;
};
